module.exports = __webpack_public_path__ + "img/norway.f2dabe68.svg";